import React, { useState, useEffect } from "react"
import ModalTiny from "react-bootstrap/Modal"

import CustomerComplaint from "../forms/customer-complaint"


const Enquiry = (props,{children}) => {

    const [modalAskformOpen,setAskformOpen] = React.useState(false);
    const openAskformModal = () => {
      setAskformOpen(true);
    }
    const closeAskformModal = () => {
      setAskformOpen(false);
    }

    return (
        <>
            <a className="yield-info" href="javascript:void(0);" onClick={openAskformModal}><div className="info-main">i</div></a>
        
            <ModalTiny show={modalAskformOpen} onHide={closeAskformModal} className="book-a-viewing-modal modal-main-form">
                <ModalTiny.Header closeButton className="contact-close-btn">
                    <ModalTiny.Title className="w-100"><h2 className="text-center mb-0">How do we calculate this?</h2>
                    </ModalTiny.Title>
                </ModalTiny.Header>
                <ModalTiny.Body className="event-section people-details-form-modal">
                    <h4>Rental yields are for guidance purposes only and cannot be guaranteed.</h4>
                    <p>Average yields are calculated based on a cash purchase of the property and take the average of the asking rent for a minimum of 10 similar properties in the same main postcode area which have been offered for rent in the preceding 6 months.</p>
                </ModalTiny.Body>
            </ModalTiny>
        </>
    )
}

export default Enquiry
